<template>
  <g :id="id">
    <defs>
      <CircleSection
        :id="`${id}-click`"
        :radius="drawing_opts.radius"
        :angle="drawing_opts.category_angle"
        :rotation="rotation"
        :close="true"
      ></CircleSection>
      <CircleSection
        :id="`${id}-arc`"
        :radius="drawing_opts.radius"
        :angle="drawing_opts.category_angle"
        :rotation="rotation"
        :inner_radius="drawing_opts.inner_radius"
        :close="false"
      ></CircleSection>
      <CircleSection
        :id="`${id}-txt-arc`"
        :radius="(drawing_opts.radius + drawing_opts.inner_radius) / 2"
        :angle="drawing_opts.category_angle"
        :rotation="rotation"
        :close="false"
      ></CircleSection>
    </defs>
    <use :fill="color" stroke="none" :xlink:href="`#${id}-arc`"/>
    <text dominant-baseline="middle">
      <textPath
        :xlink:href="`#${id}-txt-arc`"
        startOffset="50%"
        text-anchor="middle"
        >{{ name }}</textPath
      >
    </text>
    <g id="items-container" :transform="`rotate(${rad2deg(item_rotation)})`">
      <Item
        v-for="(item, index) in reversed_items"
        :name="item.name"
        :grade="item.grade"
        :grade_color="grade_color"
        :goal="item.goal"
        :goal_color="goal_color"
        :db_ref="item.db_ref"
        :index="index"
        :key="`${id}-${index}item`"
      ></Item>
    </g>
    <use
      fill="#404040"
      opacity="0"
      stroke="none"
      :xlink:href="`#${id}-click`"
      class="click-anim"
      :class="{ 'ripple': isClicking, 'unripple': !isClicking && hasClicked }"
    />
    <use
      fill="none"
      stroke="none"
      :xlink:href="`#${id}-click`"
      pointer-events="all"
      @click="click()"
      @mousedown="mousedown"
      @mouseup="isClicking = false"
      @mouseleave="isClicking = false"
      class="hover-pointer"
    />
  </g>
</template>
<script>
import { mapGetters } from "vuex";
import CircleSection from "@/components/CircleSection.vue";
import Item from "@/components/Item.vue";

export default {
  name: "CircleCategory",
  components: {
    CircleSection,
    Item
  },
  props: {
    name: String,
    color: String,
    grade_color: String,
    goal_color: String,
    items: Array,
    index: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      isClicking: false,
      hasClicked: false
    }
  },
  computed: {
    id() {
      return `cat${this.index}`;
    },
    rotation() {
      return this.index * this.$store.state.drawing_opts.category_angle;
    },
    item_rotation() {
      return (
        this.$store.state.drawing_opts.category_angle / 2 -
        this.$store.state.drawing_opts.item_angle / 2 -
        this.rotation
      );
    },
    reversed_items() {
      return this.items.slice().reverse();
    },
    ...mapGetters([
      "drawing_opts"
    ])
  },
  methods: {
    rad2deg(deg) {
      return (360 * deg) / (2 * Math.PI);
    },
    click() {
      this.$emit("click");
    },
    mousedown() {
      this.isClicking = true;
      this.hasClicked = true;
    }
  }
};
</script>
<style lang="scss" scoped>
text {
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1em;
  font-weight: bold;

  textPath {
    fill: currentColor;
  }
}
</style>
